var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{staticClass:"shop-floorplan",attrs:{"value":_vm.promise,"data-title":_vm.$t('youAreHere')}},[_c('div',{staticClass:"shop-floorplan__aspect",style:(_vm.style)},[_c('div',{ref:"map",staticClass:"shop-floorplan__map content"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }